import React, { useState } from 'react';
import BookingsTable from './components/BookingsTable';

const Bookings = () => {
  const [totalFilter, setTotalFilter] = useState(0);
  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="text-30 lh-14 fw-600">Daftar Pesanan</h1>
          <div className="d-flex">
            <button
              type="button"
              className="button -md h-50 bg-blue-1 text-white"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal">
              <i className="fa fa-filter mr-10" />
              Filter Data ( {totalFilter > 0 ? totalFilter : 0} )
            </button>
          </div>
        </div>
        <div className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20" style={{ minHeight: 540 }}>
          <BookingsTable onFilterLengthChanged={(val) => setTotalFilter(val)} />
        </div>
      </div>
    </div>
  );
};

export default Bookings;
